import cn from 'classnames';
import React, { FC, ReactNode, memo } from 'react';

import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import Typography from '@mui/material/Typography';

import Tooltip from '@components/common/Tooltip';

import { VariantTypography } from '@app-types/common/common.types';

import useStyles from './styles.module';

interface Props {
  title: string;
  value: string | ReactNode;
  titleVariant?: VariantTypography;
  valueVariant?: VariantTypography;
  tooltipContent?: string;
  valueColor?: string;
  titleColor?: string;
  className?: string;
  classNameValue?: string;
  classNameTitle?: string;
  classNameTooltip?: string;
}

const ItemStats: FC<Props> = ({
  title,
  value,
  valueVariant,
  titleVariant,
  titleColor,
  valueColor,
  tooltipContent,
  className,
  classNameValue,
  classNameTitle,
  classNameTooltip,
}) => {
  const { classes, cx } = useStyles();

  return (
    <div className={cx(classes.itemBox, className)}>
      <Typography
        variant={titleVariant || 'body1'}
        color={(theme) => titleColor || theme.secondary.s3}
        className={cn(classNameTitle)}
      >
        {title}
      </Typography>
      <Typography
        component="div"
        variant={valueVariant || 'subtitle1'}
        color={(theme) => valueColor || theme.primary.p2}
        className={cn(classes.value, classNameValue)}
      >
        {value}

        {tooltipContent && (
          <Tooltip title={tooltipContent}>
            <HelpOutlineIcon
              className={cn(classes.tooltipIcon, classNameTooltip)}
            />
          </Tooltip>
        )}
      </Typography>
    </div>
  );
};

export default memo(ItemStats);
